export { CSPInstrumentation } from './instrumentation';



// WEBPACK FOOTER //
// ../../../../src/instrumentations/csp/index.ts